import { useState } from 'react';
import { faqList } from '@/mocks/homeMock';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqList.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

      <div className="text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
          <i className="ri-question-line" />
          FAQ
        </span>
        <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">吃瓜前，你可能想问</h2>
        <p className="mt-2 text-sm text-foreground-600 md:text-base">关于速度排行与时效比拼，这里给你答案。</p>
      </div>

      <div className="mt-8 space-y-3">
        {faqList.map((f, i) => {
          const open = openIdx === i;
          return (
            <div key={f.q} className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpenIdx(open ? -1 : i)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
              >
                <h3 className="text-sm font-bold text-foreground-950 md:text-base">{f.q}</h3>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${open ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'}`}>
                  <i className={`${open ? 'ri-subtract-line' : 'ri-add-line'} text-sm`} />
                </span>
              </button>
              {open && (
                <p className="border-t border-background-100 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                  {f.a}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}